import { render } from "./MarketDynamics.vue?vue&type=template&id=05b2c2b6&scoped=true"
import script from "./MarketDynamics.vue?vue&type=script&lang=js"
export * from "./MarketDynamics.vue?vue&type=script&lang=js"

import "./MarketDynamics.vue?vue&type=style&index=0&id=05b2c2b6&scoped=true&lang=scss"

import exportComponent from "E:\\Project\\one-code-pass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b2c2b6"]])

export default __exports__